import React, { useEffect, useState } from "react";
import { formatDate } from "../../../../helpers/date";
import { Score } from "../../../../services/scoresGet";
import ScoreChart from "./ScoreChart";
import styles from "./ScoreHistory.module.scss";

interface Props {
  scores: Score[]
}

const ScoreHistory = ({ scores }: Props) => {

  const sortedScores = [...scores].sort((a, b) => {
    if (!b.ts && !a.ts) return 0;
    if (!b.ts) return -1;
    if (!a.ts) return 1;
    return b.ts - a.ts;
  });
  const [date, setDate] = useState("Última consulta:");

  useEffect(() => {
    if (sortedScores.length) {
      const score = sortedScores[0];
      const date = formatDate(score.fecha, { in: "YYYY-MM-DD" });
      setDate(`Última consulta: ${date}`);
    }
  }, [scores]);

  return (
    <div className="eb-card">
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.title}>
            Histórico del puntaje
          </p>
          <p className={styles.date}>
            {date}
          </p>
        </div>
        <ScoreChart scores={sortedScores} />
      </div>
    </div>
  )
}

export default ScoreHistory;